import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "@remix-run/react";
import { styled } from 'styled-components';
import { useInitialRender } from '../../../../../play-core/hooks/use-initial-render';
import SvgChevron from '../../../../../play-core/icons/Chevron';
import { Colors } from '../../../../../play-core/styles/Colors';
import { Device } from '../../../../../play-core/styles/Device';
import { getMappedMediaQuery } from '../../../../../play-core/styles/style-helper';
import { zIndex } from '../../../../../play-core/styles/z-index';
import { useAnalyticsDispatch } from '../../../analytics/AnalyticsContext';
import { Button } from '../../../components/ClickableComponents/Button';
import { colorSets, defaultHorizontalPadding } from '../../../components/ClickableComponents/styles';
import { containerPadding } from '../../../components/PlayContainer/PlayContainer';
import { usePath, useVideoConfig } from '../../../config/VideoAppContext';
import { jsx as _jsx } from "react/jsx-runtime";
const srgDomains = ['srf.ch', 'rts.ch', 'rsi.ch', 'rtr.ch', 'swissinfo.ch'];
export const PlayerBackButton = ({
  visible,
  isInitialLocation
}) => {
  const {
    t
  } = useTranslation();
  const {
    meta
  } = useVideoConfig();
  const navigate = useNavigate();
  const {
    homePath
  } = usePath();
  const analytics = useAnalyticsDispatch();
  const initialRender = useInitialRender();
  const shouldNavigateToHome = isInitialLocation && !initialRender && !srgDomains.some(domain => document.referrer?.includes(domain));
  const text = t(shouldNavigateToHome ? 'global.homepage' : 'global.back');
  const ariaLabel = t(shouldNavigateToHome ? `${meta.appName}, ${t('global.homepage')}` : 'global.back');
  const handleClick = () => {
    analytics({
      type: 'click-event',
      name: 'BackClick',
      value1: window.document.title
    });
    shouldNavigateToHome ? navigate(homePath) : navigate(-1);
  };
  return initialRender ? null : /*#__PURE__*/_jsx(StyledTransparentButton, {
    visible: visible,
    iconSize: 20,
    type: "text",
    fontType: "Medium",
    text: text,
    ariaLabel: ariaLabel,
    icon: /*#__PURE__*/_jsx(SvgChevron, {
      orientation: "left"
    }),
    onClick: handleClick,
    colorSet: {
      ...colorSets.transparent,
      hoverColor: Colors.WHITE,
      hoverIconColor: Colors.WHITE,
      backgroundColor: 'transparent',
      hoverBackgroundColor: 'transparent',
      activeBackgroundColor: 'transparent'
    }
  });
};
export const padding = {
  mediaQuery: [['medium', `${containerPadding.medium - defaultHorizontalPadding}px`], ['largeUp', `${containerPadding.large - defaultHorizontalPadding}px`]],
  default: `${containerPadding.small - defaultHorizontalPadding}px`
};
export const StyledTransparentButton = styled(Button).withConfig({
  shouldForwardProp: () => true
}).withConfig({
  displayName: "PlayerBackButton__StyledTransparentButton",
  componentId: "sc-fdxvk5-0"
})(["", "{display:none;}transition-property:opacity;transition-duration:0.5s;opacity:", ";position:absolute;top:12px;", ";z-index:", ";&:hover{opacity:1;}"], Device.touch, ({
  visible
}) => visible ? 1 : 0, getMappedMediaQuery(padding, 'left'), zIndex.abovePlayer);